define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'index2024-shops/component/page-content',

    // 'WebCommon/init'
], function(
    Vue,
    i18n,
    PageMixin,

    PageContent
){
    var app = new Vue({
        mixins: [PageMixin],
        components: {
            PageContent: PageContent
        },
        i18n: i18n
    });
    app.$mount('#app');

});



//////////////////
// WEBPACK FOOTER
// ./index2024-shops/main.js
// module id = 375
// module chunks = 4